import { buildBWABucketFilters } from '@adornis/accounting/bwa/api/bwaDrilldownFilter.js';
import { BWAJahresabschluss } from '@adornis/accounting/bwa/client/BWA.js';
import { openAccountingDrilldownDialog } from '@adornis/accounting/drilldown/client/AccountingDrilldown.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { PageLoader } from '@martinus/styles/client/PageLoader.js';
import { halvingWeightedAveragePrognosis } from '../accounting/api/halvingWeightedAveragePrognosis.js';
import { useAccountingMandanten } from '../accounting/client/useAccountingMandanten.js';
import { MARTINUS_ACCOUNTING_DIGIT_MULTIPLIER } from '../accounting/MartinusAccountingDigitMultiplier.js';
import { MartinusAccountingEntry } from '../quittungen/entities/MartinusAccountingEntry.js';

export const TestBWA = stateful(() => {
  const { loading, mandanten } = useAccountingMandanten();
  if (loading) return PageLoader({});

  return BWAJahresabschluss({
    // what the user *may* see — which of these are in the table is picked inside the BWA
    perspectives: mandanten.map(mandant => ({ _id: mandant._id, name: mandant.name })),

    // TODO should be init
    accountMultiplier: MARTINUS_ACCOUNTING_DIGIT_MULTIPLIER,
    defaultFiscalYear: '25/26',
    prognosis: halvingWeightedAveragePrognosis,

    // the clicked number carries the values it was bucketed by (Konten, Kostenstelle, Kostenträger,
    // Monat, Geschäftsjahr, Schule) — the drilldown opens on a filter over exactly those, which the
    // user can then edit or extend with further perspectives as more cards
    onEntriesSelected: selection =>
      void openAccountingDrilldownDialog({
        title: selection.label,
        entityClass: MartinusAccountingEntry,
        filters: buildBWABucketFilters(selection.bucket),
      }),
  });
});
